export default __webpack_public_path__ + "static/media/GPA_Banner_NewsMedia.dbd0f427.png";